import React from 'react';
import { motion } from 'framer-motion';

interface TermsOfUseProps {
  onBack?: () => void;
}

const TermsOfUse: React.FC<TermsOfUseProps> = ({ onBack }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="legal-page"
    >
      <div className="container">
        <div className="legal-content">
          {onBack && (
            <button onClick={onBack} className="back-button">
              ← Back
            </button>
          )}
          <h1>Terms of Use</h1>
          
          <section>
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing and using Cinquity's clinical trial services, you accept and agree to be bound by 
              the terms and provisions of this agreement. These terms apply to all users of our platform, 
              including sponsors, investigators, and clinical research professionals.
            </p>
          </section>

          <section>
            <h2>Scope of Services</h2>
            <p>
              Cinquity provides electronic clinical outcome assessment (eCOA) tools, clinical trial data 
              management systems, and related clinical research technologies. Our services are designed 
              to support Phase I-IV clinical trials in compliance with regulatory standards.
            </p>
          </section>

          <section>
            <h2>User Responsibilities</h2>
            <p>
              Users are responsible for ensuring proper training on our systems, maintaining data accuracy, 
              following Good Clinical Practice (GCP) guidelines, complying with applicable regulations, 
              and maintaining appropriate access controls for their clinical trial data.
            </p>
          </section>

          <section>
            <h2>Data Handling</h2>
            <p>
              All clinical trial data processed through our platform must be handled in accordance with 
              applicable privacy laws, regulations, and institutional policies. Users must obtain proper 
              informed consent and implement appropriate data protection measures.
            </p>
          </section>

          <section>
            <h2>System Availability</h2>
            <p>
              While we strive to maintain high system availability, Cinquity does not guarantee uninterrupted 
              access to our services. Scheduled maintenance will be communicated in advance, and emergency 
              maintenance may occur with minimal notice for critical system improvements.
            </p>
          </section>

          <section>
            <h2>Service Modifications</h2>
            <p>
              Cinquity reserves the right to modify, suspend, or discontinue any aspect of our services 
              at any time. Users will be provided reasonable notice for significant changes that may 
              affect their clinical trial operations.
            </p>
          </section>

          <section>
            <h2>Termination</h2>
            <p>
              Either party may terminate this agreement with appropriate notice. Upon termination, users 
              must comply with data retention requirements and regulatory obligations for their clinical 
              trial data.
            </p>
          </section>

          <div className="legal-footer">
            <p><strong>Effective Date:</strong> January 2025</p>
            <p><strong>Contact:</strong> legal@cinquity.com</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default TermsOfUse;
